import { render } from "./BatchDetailTable.vue?vue&type=template&id=3b0ea2c4"
import script from "./BatchDetailTable.vue?vue&type=script&lang=js"
export * from "./BatchDetailTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__